var _path, _path2, _mask, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnerJoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 26,
    viewBox: "0 0 38 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8843 3.0228C21.5129 2.05325 23.399 1.5 25.4038 1.5C31.5014 1.5 36.5 6.61752 36.5 13C36.5 19.3825 31.5014 24.5 25.4038 24.5C23.399 24.5 21.5129 23.9468 19.8843 22.9772C19.5991 23.2 19.3041 23.4101 19 23.6065C20.8571 24.8065 23.0521 25.5 25.4038 25.5C32.0844 25.5 37.5 19.9036 37.5 13C37.5 6.09644 32.0844 0.500003 25.4038 0.500003C23.0521 0.500003 20.8572 1.19353 19 2.39346C19.3041 2.58994 19.5991 2.79999 19.8843 3.0228Z",
    fill: "#6FCF97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1157 3.0228C16.4871 2.05325 14.601 1.50001 12.5962 1.5C6.49862 1.5 1.5 6.61752 1.5 13C1.5 19.3825 6.49862 24.5 12.5962 24.5C14.601 24.5 16.4871 23.9468 18.1157 22.9772C18.4009 23.2 18.6959 23.4101 19 23.6065C17.1429 24.8065 14.9479 25.5 12.5962 25.5C5.91563 25.5 0.5 19.9036 0.500001 13C0.500002 6.09644 5.91564 0.500004 12.5962 0.500005C14.9479 0.500005 17.1429 1.19353 19 2.39347C18.6959 2.58994 18.4009 2.8 18.1157 3.0228Z",
    fill: "#6FCF97"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_124_5443",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0001 22.5308C22.4826 20.2379 24.6924 16.8189 24.6924 12.9999C24.6924 9.18093 22.4826 5.76195 19.0001 3.4691C15.5175 5.76194 13.3078 9.18093 13.3078 12.9999C13.3078 16.8189 15.5175 20.2379 19.0001 22.5308Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0001 22.5308C22.4826 20.2379 24.6924 16.8189 24.6924 12.9999C24.6924 9.18093 22.4826 5.76195 19.0001 3.4691C15.5175 5.76194 13.3078 9.18093 13.3078 12.9999C13.3078 16.8189 15.5175 20.2379 19.0001 22.5308Z",
    fill: "#6FCF97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 22.5308L18.4502 23.366L19.0001 23.728L19.55 23.366L19.0001 22.5308ZM19.0001 3.4691L19.55 2.63387L19.0001 2.27183L18.4502 2.63387L19.0001 3.4691ZM19.55 23.366C23.2423 20.935 25.6924 17.2324 25.6924 12.9999L23.6924 12.9999C23.6924 16.4054 21.7229 19.5408 18.4502 21.6955L19.55 23.366ZM25.6924 12.9999C25.6924 8.76741 23.2423 5.06484 19.55 2.63387L18.4502 4.30433C21.7229 6.45905 23.6924 9.59445 23.6924 12.9999L25.6924 12.9999ZM18.4502 2.63387C14.7578 5.06485 12.3078 8.76741 12.3078 12.9999L14.3078 12.9999C14.3078 9.59445 16.2772 6.45905 19.55 4.30433L18.4502 2.63387ZM12.3078 12.9999C12.3078 17.2324 14.7578 20.935 18.4502 23.366L19.55 21.6955C16.2772 19.5408 14.3078 16.4054 14.3078 12.9999L12.3078 12.9999Z",
    fill: "#6FCF97",
    mask: "url(#path-3-inside-1_124_5443)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnerJoin);
export default __webpack_public_path__ + "static/media/InnerJoin.5f17e3eff3d99e6935d6c1f58d82b0c3.svg";
export { ForwardRef as ReactComponent };